import React from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';
import { iconMap } from './icons.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSvgIcon = styled.span(space, ({ imageUrl, color, themeColor, theme, size }) => `
    mask: url("${imageUrl}");
    display: inline-block;
    width: ${size || 50}px;
    height: ${size || 50}px;
    background-color: var(--button-icon-color, 
      ${themeColor && (theme.brand[themeColor] || theme.colors[themeColor]) || color || theme.colors.gray600});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `);
const SvgIcon = (_a) => {
  var _b = _a, {
    name,
    onClick
  } = _b, props = __objRest(_b, [
    "name",
    "onClick"
  ]);
  const imageUrl = iconMap[name];
  if (!imageUrl) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(StyledSvgIcon, __spreadValues({
    onClick,
    imageUrl
  }, props));
};

export { SvgIcon };
